<template>
  <div
    class="sudoku-machine"
    :style="module.containerStyle"
    :data-tangram-module-id="module.id"
  >
    <div class="sudoku-container">
      <div
        class="sudoku-list cf"
        :style="{
          backgroundImage: `url(${adaptOssImage(
            module.gridImage,
            0,
            bacHeight * 1.6
          )})`
        }"
      >
        <div
          v-for="(item, index) in indexMap"
          :key="index"
          class="sudoku-item"
          :class="{ active: item - 1 === activeIndex }"
          @click="handleClick(item)"
        >
          <div
            v-if="infoMap[item]"
            class="gift-item"
            :style="{
              backgroundImage:
                'url(' + adaptOssImage(infoMap[item].prize_img, 200) + ')'
            }"
          ></div>
        </div>
      </div>
    </div>

    <div v-if="isMemberLottery" class="change-notice member">
      <p>消耗{{ score }}积分抽奖</p>
      <p>我的积分：{{ currentTotalScore }}</p>
    </div>
    <div v-else class="change-notice normal">
      <p>
        您还有 <b>{{ remainNum }}</b> 次机会
      </p>
    </div>
  </div>
</template>

<script>
import { WIDTH } from '@/defines/env'
import { DialogAlert } from '@/utils/dialog.js'
import { ossImage } from '@/utils/oss_image'
import { loginConfirm } from '@/utils/native_interactions/login'
import { tickets } from '@/defines/user'
import { platform } from '@/defines/environment'

let count = 0
let clicked = false

export default {
  name: 'SudokuMachine', // 九宫格
  props: {
    module: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      bacHeight: WIDTH * 1.106,
      activeIndex: -1,
      remainNum: 0,
      indexMap: [1, 2, 3, 8, 9, 4, 7, 6, 5],
      infoMap: {},
      lotteryResult: '',
      lottoType: 1,
      currentTotalScore: 0,
      score: 0
    }
  },
  created() {
    const map = {}

    this.module.infoMap.forEach(item => (map[item.show_seq] = item))

    this.infoMap = map

    this.remainNum = this.module.remainNum

    this.lottoType = this.module.lottoType
    // eslint-disable-next-line eqeqeq
    this.isMemberLottery = this.lottoType == 2
    this.score = this.module.score
    this.currentTotalScore = this.module.currentTotalScore
    this.checkAble()
  },
  methods: {
    adaptOssImage(src, width = 0, height = 0) {
      return ossImage({
        src,
        width,
        height
      })
    },
    checkAble(isClick = false) {
      const lotteryStatus = this.module.lotteryStatus
      if (Number(lotteryStatus.status) !== 2) {
        DialogAlert(lotteryStatus.alert)
        return false
      }
      if (!this.isMemberLottery && isClick && this.remainNum <= 0) {
        DialogAlert('抱歉，您的抽奖次数已用完~')
        return false
      }
      if (
        this.isMemberLottery &&
        isClick &&
        this.currentTotalScore < this.score
      ) {
        DialogAlert('抱歉，您的积分不足~')
        return false
      }
      return true
    },
    ant: function () {
      count++
      if (count > 40) {
        this.activeIndex = -1
        if (this.lotteryResult) {
          DialogAlert(this.lotteryResult).then(() => {
            count = 0
          })
        } else {
          setTimeout(function () {
            count = 0
          }, 1000)
        }
        return
      }
      this.activeIndex++
      this.activeIndex = this.activeIndex % 8
      setTimeout(
        function () {
          this.ant()
        }.bind(this),
        50
      )
    },
    handleClick: async function (index) {
      if (!tickets && !window.matrix.baseParams.previewToken) {
        if (platform === 'android') {
          return loginConfirm()
        } else {
          return loginConfirm(location.href)
        }
      }
      this.postMessage({
        id: this.module.id,
        event: this.module.events.lotteryTicker
      })

      if (index === 9 && !clicked && count === 0) {
        if (!this.checkAble(true)) return

        clicked = true

        const res = await this.callModule(this.module.events.getLotteryResult)
        this.currentTotalScore = res.currentTotalScore
        this.lotteryResult = res.lotteryResult

        if (res.ret) this.remainNum--
        if (this.remainNum < 0) this.remainNum = 0
        setTimeout(function () {
          clicked = false
        }, 1000)

        this.ant()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.out-wrapper {
  display: flex;

  width: 100%;
  height: 8.6rem;

  flex-direction: column;
}

.sudoku-container {
  background-size: 100% 100%;

  margin: 0 auto 0;
  padding-top: 1.65rem;

  flex: 1;

  .sudoku-list {
    width: 5.3rem;
    height: 5.3rem;
    margin: 0 auto;
    overflow: hidden;
    background-size: 100% 100%;

    .sudoku-item {
      float: left;

      position: relative;

      width: 32%;
      height: 32%;
      margin-right: 2%;
      margin-bottom: 2%;
      padding: 2%;

      border-radius: 0.08rem;

      text-align: center;
      box-sizing: border-box;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .gift-item {
        width: 100%;
        height: 100%;

        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }

      &.active {
        .gift-item {
          display: none;
        }
      }
    }
  }
}

.change-notice {
  width: 100%;
  height: 1.65rem;
  margin: 0 auto;

  font-size: 0.32rem;

  text-align: center;
  color: white;
  background-size: 100% 100%;
  &.normal {
    line-height: 1.65rem;
    p {
      height: 100%;
    }
  }

  &.member {
    font-size: 0.24rem;

    @include flex-column-center;
  }

  b {
    font-size: 0.72rem;
    font-weight: bold;
    color: #f8e71c;
  }
}
</style>
